import React, { useState, useContext, useEffect } from "react";
import FirstStepAccount from "./createAccountComps/firstStep";
import SecondStepAccount from "./createAccountComps/secondStep";
import ThirdStepAccount from "./createAccountComps/ThirdStep";
import { Link } from "gatsby";
import { useFetchLanguages } from "hooks/Quotes/useFetchLanguages";

function CreateAccountNew() {
  const [currentStep, setCurrentStep] = useState(1);

  const [langData, setlangData] = useState();

  const { data } = useFetchLanguages();

  useEffect(() => {
    setlangData(data);
  });

  return (
    <div className="bg-[#1D1C1C] font-primary py-[80px] ">
      <div className="bg-contact-img max-w-max flex mx-auto justify-center h-4 sm:h-8">
        <h1 className="text-center  text-white text-24 sm:text-[42px]">
          Translator registration
        </h1>
      </div>
      <div className="stepS flex justify-center mx-auto pt-16 items-center gap-x-4 px-8 sm:px-4 mb-20">
        <div
          className="border rounded-full border-white text-white px-2 cursor-pointer relative bg-[#133a8d] w-7 h-7 text-center"
          // onClickCapture={() => setCurrentStep(1)}
        >
          1
          <p className="text-lg text-center text-white absolute -left-5 top-7">
            personal info
          </p>
        </div>
        <div className="w-56 border-b border-white"></div>
        <div
          // onClickCapture={() => setCurrentStep(2)}
          className={`border rounded-full  border-white text-white px-2 cursor-pointer relative w-7 h-7 text-center ${
            currentStep > 1 ? "bg-[#133a8d]" : ""
          }`}
        >
          2
          <p className="text-lg text-center text-white absolute -left-5 top-7">
            Service info
          </p>
        </div>
        <div className="w-56 border-b border-white"></div>
        <div
          // onClickCapture={() => setCurrentStep(3)}
          className={`border rounded-full  border-white text-white px-2 cursor-pointer relative w-7 h-7 text-center ${
            currentStep > 2 ? "bg-[#133a8d]" : ""
          }`}
        >
          3
          <p className="text-lg text-center text-white absolute -left-5 top-7">
            payment info
          </p>
        </div>
      </div>
      <p className="text-center text-white text-xl py-5 px-4">
        Register here for free, and we'll send you an email when we have a job
        waiting for you or{" "}
        <Link to="/user/auth/login" className="text-lightBlue font-semibold">
          log in
        </Link>
      </p>
      {currentStep == 1 ? (
        <FirstStepAccount
          currentStep={currentStep}
          // userData={userData}
          setCurrentStep={setCurrentStep}
          // setCreateAccountData={setCreateAccountData}
          // createAccountData={createAccountData}
          // setUserData={setUserData}
        />
      ) : (
        ""
      )}
      {currentStep == 2 ? (
        <SecondStepAccount
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          // setCreateAccountData={setCreateAccountData}
          // setUserData={setUserData}
          // userData={userData}
          data={langData}
          // createAccountData={createAccountData}
        />
      ) : (
        ""
      )}
      {currentStep == 3 ? (
        <ThirdStepAccount
          // createAccountData={createAccountData}
          setCurrentStep={setCurrentStep}
          // setUserData={setUserData}
          // setCreateAccountData={setCreateAccountData}
          // userData={userData}
        />
      ) : (
        ""
      )}
      <div className="w-11/12 sm:w-10/12 mx-auto max-w-4xl mt-20">
        <div className="bg-contact-img max-w-max  h-4 sm:h-8 mb-20">
          <h2 className="text-white text-24 sm:text-[42px]">
            Frequently Asked Questions
          </h2>
        </div>
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">
              What's in Tomedes for me?
            </p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] mb-10">
            <p>
              We know that you prefer to provide translation services in a
              marketplace that lets you select your projects and your rates. We
              also know that you don't like to deal with many clients.
            </p>
            <p>
              We will provide you with a single marketplace and one secure
              source for payment - Tomedes When you register with Tomedes, you
              will be able to choose everything:
            </p>
            <ul className="list-disc pl-8 my-3 flex flex-col gap-1">
              <li>
                Money - You will decide how much you are ready to be paid for
                each job.
              </li>
              <li>Time - You will decide when to work</li>
              <li>
                Jobs - You will decide which translation jobs you want to work
                on
              </li>
            </ul>
            <p>
              <Link
                to="/user/provider/createaccount"
                className="text-lightBlue"
              >
                Register for free
              </Link>{" "}
              , and we'll send you an email when we have a job waiting for you
            </p>
          </div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">How does it work?</p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] mb-10">
            <p>It's easy,</p>
            <ol className="list-decimal pl-8 my-3 flex flex-col gap-1">
              <li>
                First, you must register with Tomedes{" "}
                <Link
                  to="/user/provider/createaccount"
                  className="text-lightBlue"
                >
                  here*
                </Link>{" "}
                - It's free.
              </li>
              <li>
                We'll send you an email when we have a job waiting for you.
              </li>
              <li>
                Log in to the site and view the job's details. Place a bid only
                if you can start working immediately on that project. You will
                be able to see how your bid compares to other providers who bid
                for the same job and change your bid accordingly.
              </li>
              <li>
                Download the document and start translating it once you get an
                email announcing you won the bid.
              </li>
              <li>Upload the finished project.</li>
              <li>Get payment for the project at the end of the next month.</li>
            </ol>
          </div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">
              How is the winning translator selected?
            </p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] flex flex-col gap-5 mb-10">
            <p>
              The winning provider is chosen based on several criteria,
              including the price of his bid and his quality score (determined
              by the quality of completed projects).
            </p>
            <p>
              Tomedes does not disclose all selection criteria and we reserve
              the right to change the weight of the criteria
            </p>
            <p>
              During the bidding process, you will be able to see your rank
              compared to the rank of other providers who are bidding on the
              same project.
            </p>
          </div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">
              I have bid on several jobs and I still have not been offered one.
              What can I do?
            </p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] flex flex-col gap-5 mb-10">
            <p>
              Tomedes.com takes into account every bidder's quality score and
              the bid price each provider submits for a particular job. The
              provider with the best combination of quality and price will win
              the job.
            </p>
            <p>
              If you are new to Tomedes.com, the best way to get experience is
              to bid on a few small jobs at a relatively low rate. Once you
              successfully complete some projects and earn high quality marks,
              your rank compared to other providers will raise.d we reserve the
              right to change the weight of the criteria
            </p>
          </div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">
              When will I get paid?
            </p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] flex flex-col gap-5 mb-10">
            <p>
              Tomedes pays our translation providers at the end of every month
              for translation work done during the previous month. For example,
              if you complete four projects and your buyers approve of the work
              during the month of June, we will send you payment through at the
              end of July.
            </p>
          </div>
          <div className="flex items-center gap-2 mb-3">
            <img
              src="https://skins.tomedes.com/frontend/images/question_icon.svg"
              alt=""
              className="w-12 h-12"
            />
            <p className="text-lg text-white font-bold">How do I get paid?</p>
          </div>
          <div className="text-lg text-white font-light leading-5 pl-[56px] flex flex-col gap-5 mb-10">
            <p>
              We currently send out payments via PayPal and Moneybookers. We
              plan to offer more options in the future.
            </p>
            <p>
              We will send you the payment at the end of each month for all the
              projects finished during the previous month. For example, at the
              end of July, 2008 a payment for all the projects finished between
              June 1, 2008 and June 30, 2008 will be delivered. All you have to
              do is send us invoices/payment request (bills) by the end of each
              month for the projects completed during the month. Please indicate
              our project number/job name from Tomedes.com website and your
              payment details (both if you have performed the translation via
              the website and via our project managers). The invoice should be
              issued to Tomedes Ltd. and sent to{" "}
              <a href="mailto:billing@tomedes.com" className="text-lightBlue">
                billing@tomedes.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAccountNew;
